export default {
  filtersMap: {
    names: 'Grupos',
    themes: 'Temas',
    tags: 'Tags',
    polarities: 'Sentimento',
    dark_post: 'Tipo de Publicação',
    channels_listening: 'Canais',
    channels: 'Canais',
    uids: 'Autores',
    pages: 'Páginas',
    sac_type: 'Interações',
    sac_status: 'Status',
    sac_replier: 'Respondentes',
    contracts: 'Contrato',
    bots: 'Bot',
    category: 'Categoria',
    domains: 'Canais',
    operators: 'Atendentes',
    teams: 'Filas',
    desk_tags: 'Tags',
    scheduled: 'Campanhas',
    campaign_name: 'Nome da Campanha',
  },
  noRepliers: 'Sem respondentes',
  dateRange: 'Intervalo de tempo',
  scheduledOnly: 'Somente Agendadas',
};
